module.exports = __webpack_public_path__ + "img/eps.1d56a3ad.svg";